import { HistoryModalTranslations } from "../models/history-modal-translaction-model";

export const enUS: HistoryModalTranslations = {
  title: 'Change History',
  noData: 'No history found.',
  close: 'Close',
  headers: {
    timestamp: 'Date',
    revType: 'Type',
    userName: 'Performed By',
    carrierName: 'Carrier',
    contractName: 'Contract',
    patientName: 'Patient',
    attributeName: 'Field',
    oldValue: 'Previous Value',
    newValue: 'Current Value',
  }
};
